import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import MembershipSortingSelectBox from '../../../Component/MemberComponent/MembershipSortingSelectBox';

import { ReactComponent as SortingButtonSvg } from '../../../image/SortingButton.svg';

const ValidColumnView = (props) => {
  const { 
    selectedMembership,
    setSelectedMembership,
    genderSort,
    setGenderSort,
    birthSort,
    setBirthSort,
    startSort, 
    setStartSort, 
    endSort, 
    setEndSort, 
    classSort, 
    setClassSort 
  } = props;
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;


  // 성별 정렬 버튼 클릭시 //
  function onClickGenderSort() {
    setBirthSort('normal');
    setStartSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (genderSort === 'normal' || genderSort === 'desc') setGenderSort('asc');
    else if (genderSort === 'asc') setGenderSort('desc');
  }

  // 생년월일 정렬 버튼 클릭시 //
  function onClickBirthSort() {
    setGenderSort('normal');
    setStartSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (birthSort === 'normal' || birthSort === 'desc') setBirthSort('asc');
    else if (birthSort === 'asc') setBirthSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickStartSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (startSort === 'normal' || startSort === 'desc') setStartSort('asc');
    else if (startSort === 'asc') setStartSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickEndSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setStartSort('normal');
    setClassSort('normal');

    if (endSort === 'normal' || endSort === 'desc') setEndSort('asc');
    else if (endSort === 'asc') setEndSort('desc');
  }

  return (
    <TopLevelWrapper>
      <Column style={{marginLeft: '20px'}} width={110}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colName')}</Text>
      </Column>
      <SortingWrapper width={60}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colGender')}</Text>
      <SortingButton $sort={genderSort} onClick={() => onClickGenderSort()}/>
      </SortingWrapper>
      <SortingWrapper width={80}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colBirth')}</Text>
        <SortingButton $sort={birthSort} onClick={() => onClickBirthSort()}/>
      </SortingWrapper>
      <Column width={130}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colPhone')}</Text>
      </Column>
      <SortingWrapper width={220}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colMembership')}</Text>
        <MembershipSortingSelectBox
          value={selectedMembership}
          setValue={setSelectedMembership} />
      </SortingWrapper>
      <SortingWrapper width={75}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colStartDate')}</Text>
        <SortingButton $sort={startSort} onClick={() => onClickStartSort()}/>
      </SortingWrapper>
      <SortingWrapper width={115}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colEndDate')}</Text>
        <SortingButton $sort={endSort} onClick={() => onClickEndSort()}/>
      </SortingWrapper>
      <Column width={70}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colCount')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default ValidColumnView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 970px;
  height: 38px;

  margin-top: 10px;

  gap: 10px;
`;

const SortingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  gap: 5px;

  overflow: hidden;
`;

const SortingButton = styled(SortingButtonSvg)`
  margin-left: 4px;
  flex-shrink: 0;

  width: 20px;
  height: 20px;

  transform: ${props => props.$sort === 'asc' ? 'rotate(180deg)' : 'none'};

  & rect {
    fill: ${props => props.$sort !== 'normal' ? props.theme.primary : props.theme.buttonFill};
    transition: fill 0.3s ease-in-out;
  }

  & path:first-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  & path:last-of-type {
    fill: ${props => props.$sort !== 'normal' ? props.theme.subBackground : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
